import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';

@Directive({
	selector: '[nlfButton]'
})
export class NlfButtonDirective {
	@Input() buttonColor: string = 'primary';
	@Input() buttonStyle?: 'outline' | 'tonal' | 'ghost';
	@Input() buttonSize?: 'small' | 'default' | 'large';
	@Input() buttonOnlyIcon: boolean = false;
	@Input() buttonFullWidth?: 'desktop' | 'mobile' | 'all';

	constructor(private el: ElementRef, private renderer: Renderer2) { }

	ngOnInit() {
		this.renderer.addClass(this.el.nativeElement, 'nlf-button');

		const colorClass = `nlf-button-${this.buttonColor}`;
		this.renderer.addClass(this.el.nativeElement, colorClass);

		if (this.buttonStyle) {
			const styleClass = `nlf-button-${this.buttonColor}--${this.buttonStyle}`;
			this.renderer.addClass(this.el.nativeElement, styleClass);
		}

		if (this.buttonSize) {
			const sizeClass = `nlf-button--${this.buttonSize}`;
			this.renderer.addClass(this.el.nativeElement, sizeClass);
		}

		if (this.buttonOnlyIcon) {
			this.renderer.addClass(this.el.nativeElement, 'nlf-button--icon');
		}

		if (this.buttonFullWidth) {
			let fullWidthClass: string;
			switch (this.buttonFullWidth) {
				case 'desktop':
					fullWidthClass = 'nlf-button--desktop-full-width';
					break;
				case 'mobile':
					fullWidthClass = 'nlf-button--mobile-full-width';
					break;
				case 'all':
					fullWidthClass = 'nlf-button--full-width';
					break;
				default:
					return;
			}
			this.renderer.addClass(this.el.nativeElement, fullWidthClass);
		}
	}
}
